module.exports = __webpack_public_path__ + "static/media/SmartShop_5-762w.2b67801a.png";